import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CallsPage from './pages/CallsPage';
import MyCallsPage from './pages/MyCallsPage';
import ReportsPage from './pages/ReportsPage';
import ContactsPage from './pages/ContactsPage';
import UsersPage from './pages/UsersPage';
import Sidebar from './components/Sidebar';
// --- CRM layer pages (added Phase 6-B, additive) ---------------------------
import CrmTransfersPage from './crm/CrmTransfersPage';
import CrmOpportunitiesBoard from './crm/CrmOpportunitiesBoard';
import CrmClientPage from './crm/CrmClientPage';
import CrmOpportunityPage from './crm/CrmOpportunityPage';
import CrmAdminPage from './crm/CrmAdminPage';
import { CRM_NAV_EVENT } from './crm/crmApi';
// Phase 6-D: unified notification bell + CRM-scoped styles (Tajawal on form
// controls, which do not inherit font-family from body).
import CrmNotificationBell from './crm/CrmNotificationBell';
import './crm/crm.css';
// ---------------------------------------------------------------------------
import './App.css';

const AppContent = () => {
  const { user, loading } = useAuth();
  const getInitialPage = () => {
    const stored = localStorage.getItem('activePage');
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (stored === 'dashboard' && storedUser.role !== 'admin') return 'calls';
    return stored || (storedUser.role === 'admin' ? 'dashboard' : 'calls');
  };
  const [activePage, setActivePageRaw] = useState(getInitialPage());
  const setActivePage = (p) => { localStorage.setItem('activePage', p); setActivePageRaw(p); };

  useEffect(() => {
    if (user && activePage === 'dashboard' && user.role !== 'admin') {
      setActivePage('calls');
    }
  }, [user]);

  // Added Phase 6-B: lets existing pages jump to a CRM screen by dispatching a
  // window event, so their own rendering in renderPage() stays untouched.
  useEffect(() => {
    const handler = (e) => setActivePage(e.detail);
    window.addEventListener(CRM_NAV_EVENT, handler);
    return () => window.removeEventListener(CRM_NAV_EVENT, handler);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: 18 }}>
        جاري التحميل...
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }


  const renderPage = () => {
    switch (activePage) {
      case 'dashboard': return user.role === 'admin' ? <DashboardPage /> : <CallsPage />;
      case 'calls': return <CallsPage />;
      case 'mycalls': return <MyCallsPage />;
      case 'contacts': return <ContactsPage />;
      case 'reports': return user.role === 'admin' ? <ReportsPage /> : <DashboardPage />;
      case 'users': return user.role === 'admin' ? <UsersPage /> : <DashboardPage />;
      // --- CRM layer pages (added Phase 6-B) --------------------------------
      case 'crm-board': return <CrmOpportunitiesBoard setActivePage={setActivePage} />;
      case 'crm-transfers': return <CrmTransfersPage setActivePage={setActivePage} />;
      case 'crm-client': return <CrmClientPage setActivePage={setActivePage} />;
      case 'crm-opportunity': return <CrmOpportunityPage setActivePage={setActivePage} />;
      case 'crm-admin': return user.role === 'admin' ? <CrmAdminPage setActivePage={setActivePage} /> : <CallsPage />;
      // ----------------------------------------------------------------------
      default: return user?.role === 'admin' ? <DashboardPage /> : <CallsPage />;
    }
  };

  return (
    <div className="app">
      <Sidebar activePage={activePage} setActivePage={setActivePage} />
      {/* Phase 6-D: fixed-position bell. The app has no top bar, so it floats
          over the content area rather than requiring a layout change. */}
      <CrmNotificationBell />
      <main className="main-content">
        {renderPage()}
      </main>
    </div>
  );
};

const App = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;